import { EmptyPlaceholder } from '@client/toolkit';
import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';

export const NoDataWidget = ({ title, noDataText }: { title: string; noDataText: string }) => {
  return (
    <DashboardCardWrapper title={title}>
      <NoDataWidgetContent noDataText={noDataText} />
    </DashboardCardWrapper>
  );
};

export function NoDataWidgetContent({ noDataText }: { noDataText: string }) {
  return (
    <div data-testid="no-data-widget" className="w-full min-h-[250px] h-full flex items-center justify-center">
      <EmptyPlaceholder>{noDataText}</EmptyPlaceholder>
    </div>
  );
}
